import { ComparatorStep } from '@kizi/comparator-core';

const apply: ComparatorStep = {
  path: 'apply',
  name: 'apply',
  fields: [
    {
      name: 'wizardSteps',
      validator: 'required',
    },
    {
      name: 'orderId',
    },
    {
      name: 'dynamicFormValues',
    },
    {
      name: 'validatedField',
    },
  ],
};

export default apply;
